import { ActivatedRouteSnapshot, ResolveFn, Route, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { LaborProtokollService } from '../labor-protokoll.service';
import { ILaborProtokoll } from '@mng/mgs-lib';
import { LABOR_PROTOKOLL_DETAIL_PATH } from '../../../mgs-path-defs';

const laborProtokollDetailResolver: ResolveFn<ILaborProtokoll> = async (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const laborProtokollService = inject(LaborProtokollService);
  const id = +route.queryParams['id'];
  if (id) {
    return laborProtokollService.laborProtokoll(id);
  }
};

export const laborProtokollDetailRoute: Route = {
  path: LABOR_PROTOKOLL_DETAIL_PATH,
  title: 'Labor Protokoll Detail',
  loadComponent: () => import('./laborprotokoll-detail.component').then((c) => c.LaborprotokollDetailComponent),
  resolve: { laborProtokollDetail: laborProtokollDetailResolver }
};
